import React from 'react';

import { SelectWithConfirm } from 'shared-components';

import { DropdownOptions } from './helpers';
import { TravelStatusEnum } from 'types';

interface IProps {
  setArrivalStatus: (arrivalStatus: TravelStatusEnum) => void;
  setIsEdited: () => void;
  arrivalStatus: TravelStatusEnum | undefined;
}

export const ArrivalStatusSelection = ({ setArrivalStatus, arrivalStatus, setIsEdited }: IProps) => {
  const handleStatusChange = (evt: React.FormEvent<HTMLSelectElement>) => {
    setIsEdited();
    setArrivalStatus(evt.currentTarget.value as TravelStatusEnum);
  };

  return (
    <>
      <SelectWithConfirm
        id={'arrivalStatus'}
        label="Arrival status"
        options={DropdownOptions}
        value={arrivalStatus}
        placeHolder="Select..."
        onChange={(evt: any) => handleStatusChange(evt)}
      />
    </>
  );
};
